import CacheMachine from '@/common/utils/CacheMachine'

let shopDetailGalleryList = {
  title: '',
  pics: []
}

let shopBaseDetail = new CacheMachine({})
let currentShopBaseDetail = {}

let bizoppDetail = new CacheMachine({})
let currentBizoppDetail = {}
let currentBizoppBillAccount = {}
let allConfig = new CacheMachine({})
let currentAllConfig = {}

let contractorDetail = new CacheMachine({})
let currentContractorDetail = {}
const saleData = {}

let showDatePick = false
let showPicker = false
let backoutApply = false

export default {
  shopDetailGalleryList,
  currentShopBaseDetail,
  shopBaseDetail,
  currentBizoppBillAccount,
  contractorDetail,
  currentContractorDetail,
  bizoppDetail,
  currentBizoppDetail,
  showDatePick,
  showPicker,
  backoutApply,
  allConfig,
  currentAllConfig,
  saleData
}
